// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"587cec44","598":"e0beb1d8","703":"4c253f4d","787":"c4e7f8f9"}[chunkId] + ".chunk.js";
};